import { useMutation } from "react-query";
import { t } from "@/i18n-js/instance";
import { reactQueryPost } from "@/react/helpers/backendRequestHelpers";
import { courses } from "@/react/helpers/urlHelpers/internalApi/courses";
import { useToast } from "@circle-react-uikit/ToastV2";

export const useExportEngagementData = ({ space }) => {
  const toast = useToast();

  const { mutate: exportCSV } = useMutation(
    export_type =>
      reactQueryPost(courses.exports({ courseId: space.id }), {
        export_type,
      }),
    {
      onSuccess: () => {
        toast.success(t("courses.admin_summary.comments_export_started"));
      },
      onError: () => {
        toast.error(t("errors.messages.encountered_an_issue"));
      },
    },
  );

  return { exportCSV };
};
